import { MesfModal } from "@dexteel/mesf-core";
import {
	Button,
	FormControl,
	FormHelperText,
	Grid2 as Grid,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ButtonWithLoading } from "../../../../../../controls/buttons/ButtonWithLoading";
import { Grade } from "../../../../models/Catalogs";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean, gradeId?: number) => void;
	grades: Grade[];
	isLoading?: boolean;
};

export const RequireGradeModal = ({
	show,
	onHide,
	grades,
	isLoading = false,
}: Props) => {
	const [selectedGradeId, setSelectedGradeId] = useState<number | null>(null);
	const [error, setError] = useState(false);
	const [touched, setTouched] = useState(false);

	const handleSubmit = () => {
		setTouched(true);
		if (!selectedGradeId) {
			setError(true);
			return;
		}
		onHide(true, selectedGradeId);
	};

	useEffect(() => {
		if (show) {
			setSelectedGradeId(null);
			setError(false);
			setTouched(false);
		}
	}, [show]);

	const handleChange = (value: number) => {
		setSelectedGradeId(value);
		if (value) {
			setError(false);
		}
	};

	return (
		<MesfModal
			title="GRADE REQUIRED"
			open={show}
			handleClose={() => onHide(false)}
			id="require-grade-modal"
			maxWidth="sm"
		>
			<MesfModal.Content dividers style={{ padding: "15px 30px" }}>
				<Grid container spacing={2}>
					<Grid size={{ xs: 12 }}>
						<Typography variant="body1">
							Please select a grade before closing the heat.
						</Typography>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<FormControl variant="outlined" fullWidth error={touched && error}>
							<InputLabel id="grade-selector-label">Grade</InputLabel>
							<Select
								fullWidth
								labelId="grade-selector-label"
								id="grade-selector"
								value={selectedGradeId || ""}
								onChange={(e) => handleChange(Number(e.target.value))}
								label="Grade"
								error={touched && error}
							>
								{grades.map(({ GradeId, GradeName }) => (
									<MenuItem key={`grade-${GradeId}`} value={GradeId}>
										{GradeName}
									</MenuItem>
								))}
							</Select>
							{touched && error && (
								<FormHelperText>Grade is required</FormHelperText>
							)}
						</FormControl>
					</Grid>
				</Grid>
			</MesfModal.Content>

			<MesfModal.Actions>
				<Grid container spacing={2} justifyContent="flex-end">
					<Grid size={{ md: 6, xs: 12 }} style={{ margin: 0 }}>
						<Button
							fullWidth
							variant="contained"
							color="inherit"
							onClick={() => onHide(false)}
						>
							Cancel
						</Button>
					</Grid>
					<Grid size={{ md: 6, xs: 12 }} style={{ margin: 0 }}>
						<ButtonWithLoading
							fullWidth
							isLoading={isLoading}
							disabled={isLoading}
							variant="contained"
							color="primary"
							onClick={handleSubmit}
						>
							Save
						</ButtonWithLoading>
					</Grid>
				</Grid>
			</MesfModal.Actions>
		</MesfModal>
	);
};
